<div class="wrapper">
  <nav>
    <a routerLink="">
      <img src="/assets/logo-variations/inline_icon_and_wordmark.svg" alt="Unliminno Logo">
    </a>
  </nav>

  <router-outlet></router-outlet>

  <footer>
    <div class="center">
      <p>&copy; 2026 Unlimited Innovations LLC (unliminno)</p>
    </div>
  </footer>
</div>
